import React from 'react';

interface AspectRatioIconProps {
    color?: string;
}

export const AspectRatioIcon16x9: React.FC<AspectRatioIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-6 h-6" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="6" width="20" height="12" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
);

export const AspectRatioIcon1x1: React.FC<AspectRatioIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-6 h-6" preserveAspectRatio="xMidYMid meet">
        <rect x="2" y="2" width="20" height="20" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
);

export const AspectRatioIcon9x16: React.FC<AspectRatioIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-6 h-6" preserveAspectRatio="xMidYMid meet">
        <rect x="6" y="2" width="12" height="20" stroke={color} fill="none" strokeWidth="1.5"/>
    </svg>
); 